import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = {
  rowspan: "3",
  class: "align-middle"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_11 = { class: "d-flex justify-content-center align-items-center gap-3" }
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-body px-4" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["src"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Paramétrage", -1)),
            _createVNode(_component_router_link, {
              to: "/liste-parametre",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_7, [
                  (_ctx.filteredMedia.length > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.getUrlApiForFiles('Parametres', _ctx.filteredMedia[0].nomMedia),
                        alt: "Profile",
                        class: "img-thumbnail",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal(_ctx.filteredMedia[0].nomMedia, 'image'))),
                        style: {"width":"160px","height":"160px"}
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Clé:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.parametre?.cle), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Libellé:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.parametre?.libelle), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                  _createElementVNode("strong", null, "Date:")
                ], -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.parametre?.createdAt)), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAutre, (media, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "me-3"
              }, [
                (media.nomMedia && _ctx.isImage(media.nomMedia))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getUrlApiForFiles('Parametres', media.nomMedia),
                      alt: "Autre Media",
                      class: "img-thumbnail",
                      onClick: ($event: any) => (_ctx.openModal(media.nomMedia, 'image')),
                      style: {"width":"120px","height":"120px"}
                    }, null, 8, _hoisted_12))
                  : (media.nomMedia && _ctx.isPdf(media.nomMedia))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "img-thumbnail",
                        onClick: ($event: any) => (_ctx.openModal(media.nomMedia, 'pdf')),
                        style: {"width":"120px","height":"120px","display":"flex","justify-content":"center","align-items":"center"}
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", {
                          class: "fa fa-file-pdf",
                          style: {"font-size":"40px","color":"red"}
                        }, null, -1)
                      ]), 8, _hoisted_13))
                    : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h6", { class: "modal-title" }, "Fichier"),
            _createElementVNode("button", {
              type: "button",
              id: "close-modal",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.modalType === 'image')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: _ctx.getUrlApiForFiles('Parametres', _ctx.modalMedia),
                    alt: "Image",
                    class: "img-fluid"
                  }, null, 8, _hoisted_19)
                ]))
              : (_ctx.modalType === 'pdf')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("embed", {
                      src: _ctx.getUrlApiForFiles('Parametres', _ctx.modalMedia),
                      type: "application/pdf",
                      width: "100%",
                      height: "600px"
                    }, null, 8, _hoisted_21)
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}